import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { injectIntl } from 'react-intl';

import { sortList } from 'utilities';
class TableHeaderIndex extends React.Component {
    sortList = (head) => {
        const { header, action, sort, data } = this.props;
        var list = [...data];
        if (head.sortTitle && typeof head.sortTitle === 'object') {
            list = sortList(head.order, list, head.sortTitle[0]);
            list = sortList(head.order, list, head.sortTitle[1]);
        } else {
            list = sortList(head.order, list, head.sortTitle);
        }
        header.map((item) => {
            item.id === head.id ? (item.active = true) : (item.active = false);
            item.id === head.id ? (item.order = !item.order) : (item.order = true);
        });
        action && action(header);
        sort(list);
    };
    checkMobile = (header) => {
        const { width } = this.props;
        if(width < 1700 && header.desktop){
            return false;
        } else if (width < 1550 && header.laptop) {
            return false;
        } else if (width < 1100 && header.tablet) {
            return false;
        } else if (width < 800 && header.mobile) {
            return true;
        } else if (width > 800) {
            return true;
        } else {
            return false;
        }
    };
    checkShow = (header) => {
        if (header.hide) {
            return false;
        } else {
            return true;
        }
    };
    render() {
        const { intl, header, theme, data, headerFontSize } = this.props;
        this.styles = styles(theme, headerFontSize);

        const visibleHeaders = header.filter(head => this.checkMobile(head) && this.checkShow(head));
        const hasGroups = visibleHeaders.some(head => head.groupLabel);

        if (!hasGroups) {
            return (
                <tr className={css(this.styles.tr)}>
                    {visibleHeaders.map((head, i) => (
                        <td
                            key={'Header' + head.title + i}
                            width={head.width}
                            className={css(head.active ? this.styles.thActive : this.styles.th)}
                            style={head.style}
                            colSpan={head.col || '1'}
                            onClick={() => data && head.sortable && this.sortList(head)}>
                            <span className={css(head.active ? this.styles.activeText : this.styles.regText)}>
                                {intl.formatMessage({ id: head.title, defaultMessage: head.defaultTitle })}
                            </span>{' '}
                            {head.sortable && (
                                <i className={`material-icons ${css(head.active ? this.styles.iconActive : this.styles.icon)}`}>
                                    {`arrow_drop_${head.order ? 'down' : 'up'}`}
                                </i>
                            )}
                        </td>
                    ))}
                </tr>
            );
        }

        // Build two-row grouped header
        const topCells = [];
        const bottomCells = [];
        let i = 0;
        while (i < visibleHeaders.length) {
            const head = visibleHeaders[i];
            if (head.groupLabel) {
                // Collect consecutive columns with the same groupLabel
                const groupLabel = head.groupLabel;
                const groupStart = i;
                while (i < visibleHeaders.length && visibleHeaders[i].groupLabel === groupLabel) {
                    i++;
                }
                const groupSpan = i - groupStart;
                // Top row: group label cell spanning all columns in group
                topCells.push(
                    <td
                        key={'GroupHeader' + groupLabel}
                        colSpan={groupSpan}
                        className={css(this.styles.th)}
                        style={{ textAlign: 'center' }}>
                        <span>{groupLabel}</span>
                    </td>
                );
                // Bottom row: individual sortable sub-headers
                for (let j = groupStart; j < i; j++) {
                    const subHead = visibleHeaders[j];
                    bottomCells.push(
                        <td
                            key={'SubHeader' + subHead.title + j}
                            width={subHead.width}
                            className={css(subHead.active ? this.styles.thActive : this.styles.th)}
                            style={{ ...subHead.style, whiteSpace: 'nowrap' }}
                            onClick={() => data && subHead.sortable && this.sortList(subHead)}>
                            <span className={css(subHead.active ? this.styles.activeText : this.styles.regText)}>
                                {intl.formatMessage({ id: subHead.title, defaultMessage: subHead.defaultTitle })}
                            </span>{' '}
                            {subHead.sortable && (
                                <i className={`material-icons ${css(subHead.active ? this.styles.iconActive : this.styles.icon)}`}>
                                    {`arrow_drop_${subHead.order ? 'down' : 'up'}`}
                                </i>
                            )}
                        </td>
                    );
                }
            } else {
                // Non-grouped column: spans both rows
                topCells.push(
                    <td
                        key={'Header' + head.title + i}
                        width={head.width}
                        rowSpan={2}
                        className={css(head.active ? this.styles.thActive : this.styles.th)}
                        style={{ ...head.style, verticalAlign: 'middle' }}
                        colSpan={head.col || '1'}
                        onClick={() => data && head.sortable && this.sortList(head)}>
                        <span className={css(head.active ? this.styles.activeText : this.styles.regText)}>
                            {intl.formatMessage({ id: head.title, defaultMessage: head.defaultTitle })}
                        </span>{' '}
                        {head.sortable && (
                            <i className={`material-icons ${css(head.active ? this.styles.iconActive : this.styles.icon)}`}>
                                {`arrow_drop_${head.order ? 'down' : 'up'}`}
                            </i>
                        )}
                    </td>
                );
                i++;
            }
        }

        // A hidden first row whose cells each correspond to exactly one column (no colspan/rowspan).
        // tableLayout: fixed determines column widths only from the first row, so without this row
        // a colSpan group-header cell (e.g. "Trends") causes the browser to divide remaining space
        // equally, making each sub-column ~167 px instead of the intended 90 / 90 / 140 px.
        // This row is visually suppressed (height 0, visibility hidden) but anchors the correct widths.
        const colWidthRow = (
            <tr aria-hidden="true" style={{ visibility: 'hidden', height: 0 }}>
                {visibleHeaders.map((head, idx) => (
                    <td
                        key={'ColWidth' + idx}
                        width={head.width}
                        style={{ padding: 0, height: 0, lineHeight: 0, border: 'none', overflow: 'hidden' }}
                    />
                ))}
            </tr>
        );

        return (
            <>
                {colWidthRow}
                <tr className={css(this.styles.tr, this.styles.trNoBottom)}>{topCells}</tr>
                <tr className={css(this.styles.tr, this.styles.trNoTop)}>{bottomCells}</tr>
            </>
        );
    }
}

TableHeaderIndex.defaultprops = {
    headerFontSize: 12
};

const mapStateToProps = ({ app }) => {
    const { width, theme } = app;
    return { width, theme };
};

export default injectIntl(withRouter(connect(mapStateToProps)(TableHeaderIndex)));

const styles = (theme, headerFontSize) =>
    StyleSheet.create({
        tr: {
            borderTop: `solid 2px ${theme.color.compColor}`,
            borderBottom: `solid 1px ${theme.color.borderColor}`,
            color: theme.color.fontColor,
            width: '100%',
            userSelect: 'none'
        },
        trNoBottom: {
            borderBottom: 'none',
            borderTop: 'none',
        },
        trNoTop: {
            borderTop: 'none',
        },
        thActive: {
            fontSize: headerFontSize,
            color: theme.color.fontColor,
            ':hover': {
                cursor: 'pointer',
                opacity: '.8'
            }
        },
        th: {
            fontSize: headerFontSize,
            ':hover': {
                cursor: 'pointer',
                opacity: '.8'
            }
        },
        iconActive: {
            color: theme.color.themeColor,
            fontSize: 20
        },
        icon: {
            color: theme.color.fontColor,
            fontSize: 20
        },
        activeText: {
            textDecoration: 'underline',
            textDecorationColor: theme.color.themeColor
        },
        regText: {
            textDecoration: 'underline',
            textDecorationColor: 'white'
        }
    });
